import { RouterHistory } from '../Router';
import {
  initSentry,
  captureExceptionEvent as captureSentryExceptionEvent,
  addDiagnosticEvent as addSentryDiagnosticEvent,
} from './sentry';

export type DiagnosticEventLevel = 'fatal' | 'error' | 'warning' | 'log' | 'info' | 'debug';

export type DiagnosticEvent = {
  message: string;
  level: DiagnosticEventLevel;
  tags?: Record<string, string | number>;
};

export const initObservability = ({ history }: { history: RouterHistory }) => {
  initSentry({ history });
};

export const captureExceptionEvent = (error: Error, tags: Record<string, string | number> = {}) => {
  captureSentryExceptionEvent(error, tags);
};

export const addDiagnosticEvent = ({ message, level, tags = {} }: DiagnosticEvent) => {
  addSentryDiagnosticEvent({ message, level, tags });
};
